const initialState = {
    Bordereaux: [],
  };
  export default function (state = initialState, action) {
    switch (action.type) {
      case "BORDEREAUX_SELECT":
        return {
          ...state,
          Bordereaux: action.payload,
        };
      default:
        return state;
    }
  }
  